var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 391,
    viewBox: "0 0 360 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.34 -194.921C319.742 -143.189 405.405 26.3477 353.673 183.75C301.941 341.152 132.404 426.815 -24.998 375.083C-182.4 323.351 -268.063 153.815 -216.331 -3.58763C-164.599 -160.99 4.93733 -246.653 162.34 -194.921Z",
    fill: "#C7222A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-50.297 161.841L128.62 3.94678H-186.964L-50.297 161.841Z",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-49.443 162.739L-0.637558 219.183C36.9325 202.951 81.2502 193.503 128.745 193.644H129.442V4.69742L-49.443 162.739Z",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.442 369.334V194.504H128.743C81.5021 194.504 37.623 203.878 0.0498199 219.978L129.442 369.334Z",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-96.7362 296.164L128.385 369.78L-0.913773 220.393C-42.4211 238.389 -75.8444 264.71 -96.7362 296.164Z",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-120 370.175H126.805L-97.3055 296.889C-111.824 319.258 -119.898 344.096 -120 370.175Z",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M310.029 162.55L346.5 4.5",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M345.872 3.94678H131.262L309.729 161.618L345.872 3.94678Z",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.135 193.644C178.432 193.503 222.749 202.951 260.517 219.184L309.323 162.739L130.438 4.69743V193.644H131.135Z",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.137 194.504H130.438V369.333L259.632 219.977C222.254 203.878 178.179 194.504 131.137 194.504Z",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M347.873 196.613L310.075 163.259L261.481 219.458C271.628 223.845 278.922 226.243 284.462 227.839C286.527 228.433 288.361 228.92 290.014 229.358C292.862 230.113 295.174 230.726 297.203 231.506C303.646 233.98 307.426 238.184 317.457 253.52L347.873 196.613Z",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M284.27 228.784C278.59 227.228 271.137 224.842 260.796 220.392L132.472 368.654L317.302 253.845C307.108 238.247 303.359 234.429 297.107 232.212C295.51 231.645 293.743 231.182 291.645 230.662C291.242 230.562 290.826 230.46 290.398 230.355C288.604 229.914 286.584 229.418 284.27 228.784Z",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopImg);
export default __webpack_public_path__ + "static/media/top-img.376eaea418ceb6433f82363426b79f98.svg";
export { ForwardRef as ReactComponent };